import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { clsx } from "clsx";
export const Code = ({ children, language, className, showCopy = false })=>{
    const [copied, setCopied] = useState(false);
    const handleCopy = async ()=>{
        try {
            const text = typeof children === 'string' ? children : String(children);
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch (error) {
        // Failed to copy
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx('relative group', className),
        children: [
            /*#__PURE__*/ _jsx("pre", {
                className: "bg-gray-100 text-gray-800 rounded-lg p-4 overflow-x-auto text-sm font-mono",
                children: /*#__PURE__*/ _jsx("code", {
                    className: language ? `language-${language}` : '',
                    children: children
                })
            }),
            showCopy && /*#__PURE__*/ _jsx("button", {
                onClick: handleCopy,
                className: "absolute top-2 right-2 px-3 py-1 bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity",
                children: copied ? 'Copied!' : 'Copy'
            })
        ]
    });
};
export const InlineCode = ({ children, className })=>{
    return /*#__PURE__*/ _jsx("code", {
        className: clsx('px-1.5 py-0.5 bg-gray-100 text-gray-900 rounded text-sm font-mono', className),
        children: children
    });
};
